const defaultColumns = [{
    width: 576, col: 1, size: 15,
}, {
    width: 768, col: 2, size: 12,
}, {
    width: 1200, col: 4, size: 12,
}, {
    width: 1600, col: 5, size: 15,
}];

export default defaultColumns;
